module.exports = __webpack_public_path__ + "assets/images/template/project/surgical-mask/desktop.svg?v=44205e8a";